/**
 * External Dependencies
 */
import 'jquery';

import 'slick-carousel'

$(document).ready(() => {

  //
  // Videos Component
	//
	// if ( $('.video__wrapper').length ) {
	// 	$('.video__video, .play').click(() => {
	// 		$('.video__video-wrapper iframe')[0].src += '&autoplay=1';
	// 		$('.video__video').addClass('video-active');
	// 		$('.video__two-columns').addClass('video-active');
	// 	});
	// }

  function loadCanvas() {

    if ( $('#canvas').length > 0) {
      // Little Canvas things
      var canvas = document.querySelector("#canvas"),
          ctx = canvas.getContext('2d');

      // Set Canvas to be window size
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      // Configuration, Play with these
      var config = {
        particleNumber: 800,
        maxParticleSize: 10,
        maxSpeed: 40,
        colorVariation: 50
      };

      // Colors
      var colorPalette = {
        matter: [
          {r:0,g:0,b:0}, // darkPRPL
          {r:0,g:0,b:0}, // rockDust
          {r:0,g:0,b:0}, // solorFlare
          {r:0,g:0,b:0} // totesASun
        ]
      };

      // Some Variables hanging out
      var particles = [],
          centerX = canvas.width / 2,
          centerY = canvas.height / 2,
          drawBg,

      // Draws the background for the canvas, because space
      drawBg = function (ctx, color) {
          ctx.clearRect(0,0,canvas.width,canvas.height);
      };

      // Particle Constructor
      var Particle = function (x, y) {
          // X Coordinate
          this.x = x || Math.round(Math.random() * canvas.width);
          // Y Coordinate
          this.y = y || Math.round(Math.random() * canvas.height);
          // Radius of the space dust
          this.r = Math.ceil(Math.random() * config.maxParticleSize);
          // Color of the rock, given some randomness
          this.c = colorVariation(colorPalette.matter[Math.floor(Math.random() * colorPalette.matter.length)],true );
          // Speed of which the rock travels
          this.s = Math.pow(Math.ceil(Math.random() * config.maxSpeed), .7);
          // Direction the Rock flies
          this.d = Math.round(Math.random() * 360);
      };

      // Provides some nice color variation
      // Accepts an rgba object
      // returns a modified rgba object or a rgba string if true is passed in for argument 2
      var colorVariation = function (color, returnString) {
          var r,g,b,a, variation;
          r = Math.round(((Math.random() * config.colorVariation) - (config.colorVariation/2)) + color.r);
          g = Math.round(((Math.random() * config.colorVariation) - (config.colorVariation/2)) + color.g);
          b = Math.round(((Math.random() * config.colorVariation) - (config.colorVariation/2)) + color.b);
          a = 1;
          if (returnString) {
              return "rgba(" + r + "," + g + "," + b + ", 1)";
          } else {
              return {r,g,b,a};
          }
      };

      // Used to find the rocks next point in space, accounting for speed and direction
      var updateParticleModel = function (p) {
          var a = 180 - (p.d + 90); // find the 3rd angle
          p.d > 0 && p.d < 180 ? p.x += p.s * Math.sin(p.d) / Math.sin(p.s) : p.x -= p.s * Math.sin(p.d) / Math.sin(p.s);
          p.d > 90 && p.d < 270 ? p.y += p.s * Math.sin(a) / Math.sin(p.s) : p.y -= p.s * Math.sin(a) / Math.sin(p.s);
          return p;
      };

      // Just the function that physically draws the particles
      // Physically? sure why not, physically.
      var drawParticle = function (x, y, r, c) {
          ctx.beginPath();
          ctx.fillStyle = c;
          ctx.arc(x, y, r, 0, 2*Math.PI, false);
          ctx.fill();
          ctx.closePath();
      };

      // Remove particles that aren't on the canvas
      var cleanUpArray = function () {
          particles = particles.filter((p) => { 
            return (p.x > -100 && p.y > -100); 
          });
      };


      var initParticles = function (numParticles, x, y) {
          for (let i = 0; i < numParticles; i++) {
              particles.push(new Particle(x, y));
          }
          particles.forEach((p) => {
              drawParticle(p.x, p.y, p.r, p.c);
          });
      };

      // That thing
      window.requestAnimFrame = (function() {
        return window.requestAnimationFrame ||
           window.webkitRequestAnimationFrame ||
           window.mozRequestAnimationFrame ||
           function(callback) {
              window.setTimeout(callback, 1000 / 60);
           };
      })();


      // Our Frame function
      var frame = function () {
        // Draw background first
        drawBg(ctx, colorPalette.bg);
        // Update Particle models to new position
        particles.map((p) => {
          return updateParticleModel(p);
        });
        // Draw em'
        particles.forEach((p) => {
            drawParticle(p.x, p.y, p.r, p.c);
        });
        // Play the same song? Ok!
        window.requestAnimFrame(frame);
      };

      // Click listener
      canvas.addEventListener("click", function (event) {
          var x = event.clientX,
              y = event.clientY;
          cleanUpArray();
          initParticles(config.particleNumber, x, y);
      });

      // First Frame
      frame();

      // First particle explosion
      initParticles(config.particleNumber);
    }

  }

	//
  // Hamburger Component
	//
	$('.header__hamburger').click((e) => {
		e.preventDefault();
		$('.off-canvas, .header__hamburger').toggleClass('active');
		let text = $('.label', this).text();
		$('.label', this).text(
        text == 'Menu' ? 'Close' : 'Menu');
	});

  if ( $('.form-block').length ) {
    let course = $('.form-block').attr('data-code')
    if ( course ) {
      $('input[name="input_4"]').val(course)
      $('input[name="input_4"]').parent().parent().hide();
    }
  }

	//
  // Slider Component
	//
	if($('.slider').length) {
		$('.slider').slick({
			slidesToShow: 1.3,
			slidesToScroll: 1,
			mobileFirst: true,
			centerPadding: '40px',
			infinite: false,
			dots: true,
			arrows: false,
			responsive: [
				{
					breakpoint: 768,
					settings: 'unslick'
				}
			]
		});
  }

  //
  // Dashboard links slider
  function links() {
    let $gallerySlider = $('.links-slider'); 
    $gallerySlider.each(function() {
      $(this).slick({
        autoplay: false,
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        adaptiveHeight: false,
        centerMode: false,
        initialSlide: 0,
        centerPadding: '10%',
        responsive: [
          {
            breakpoint: 812,
            settings: {
              centerPadding: '10%',
            },
          },
          {
            breakpoint: 768,
            settings: {
              centerPadding: '10%',
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              centerPadding: '10px',
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              centerPadding: '10px',
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  }
  
  links();

	//
  // Finished
	//
	$('.finished__btn').click(function (e) {
    e.preventDefault();
    var lessonId = $(this).attr('data-lesson-id'),
        courseId = $(this).attr('data-course-id'),
        userId   = $(this).attr('data-user-id');
    if ($(this).hasClass('completed')) {
      // $.ajax({
      //   type: 'POST',
      //   dataType: 'json',
      //   url: window.siteOptions.ajaxurl,
      //   data: {
      //     action: 'now_remove_finished_lesson',
      //     lesson_id: lessonId,
      //     course_id: courseId,
      //     user_id: userId
      //   },
      //   success: function success(data) {
      //     console.log(data);
      //     $('.finished__btn').text('Yep, mark as completed.').removeClass('completed');
      //     $('.finished__next').removeClass('completed');
      //   }
      // });
    } else {
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.siteOptions.ajaxurl,
        data: {
          action: 'now_finished_lesson',
          lesson_id: lessonId,
          course_id: courseId,
          user_id: userId
        },
        success: function success(data) {
          console.log(data);
          $('.finished__btn').text('Completed').addClass('completed');
          $('.finished__next').addClass('completed');
        }
      });
    }
  });

  if ( $('body').hasClass('single-lesson') ) {
    $('.finished__btn').click();
  }

	$(document).on('click', '.account__cancel-initial', function(e){
    e.preventDefault();
    $('.account__sure').show();
  });

  $(document).on('click', '.account__sure .no', function(e){
    e.preventDefault();
    $('.account__sure').hide();
  });

  $(document).on('click', '.account .cancel', function(e){
    e.preventDefault();
    let user_id = $(this).attr('data-user-id');
    let stripe_id = $(this).attr('data-stripe-id');
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: window.siteOptions.ajaxurl,
      data: {
        action: 'now_cancel_membership',
        user_id: user_id,
        stripe_id: stripe_id
      },
      success: function(data) {
        $('.account__sure ul, .account__cancel-initial').hide();
        $('.account__sure p').text('Your subscription has been cancelled and you have been removed from your course.');
      }
    });
  });

  $('.new-payment-method').click(function(e){
  	e.preventDefault();
  	$('.account__payment-form').slideToggle();
  })

  $('.newsletter__egg').click(function(e){
    loadCanvas();
    $('#canvas').addClass('active');
    setTimeout(function(){
      $('#canvas').removeClass('active');
    }, 5000)
  })

  $(document).on('click', '.account__details .payment-methods__remove', function(e){
    e.preventDefault();
    let payment_method_id = $(this).attr('data-card-id');
    let card = $(this).closest('.payment-methods__item');
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: window.siteOptions.ajaxurl,
      data: {
        action: 'now_remove_card',
        payment_method_id: payment_method_id
      },
      success: function(data) {
        card.fadeOut();
      }
    });
  });

  $(document).on('click', '.account__details .payment-methods__make-default', function(e){
    e.preventDefault();
    let customer_id = $(this).attr('data-customer-id');
    let payment_method_id = $(this).attr('data-card-id');
    let button = $(this);
    let card = $(this).closest('.payment-methods__item');
    $.ajax({
      type: 'POST',
      dataType: 'html',
      url: window.siteOptions.ajaxurl,
      data: {
        action: 'now_make_default_payment_method',
        customer_id: customer_id,
        payment_method_id: payment_method_id
      },
      success: function(data) {
        button.fadeOut();
        $('.payment-methods__item').removeClass('default');
        card.addClass('default');
      }
    });
  });

  //
  // Add active class to search
  if($('.search-field').length) {
    $('.search-field').on('input',function(){
      if($(this).val() == ''){
        $(this).next().removeClass("active");
      }else{
        $(this).next().addClass("active");
      }
    });
  }

});
